export default __webpack_public_path__ + "static/bg-section-9-1482275db706dd249fafe48ceabcc2d9.svg";